/* ============================================================
   NextSells — interactividad (vanilla JS, sin dependencias)
   ============================================================ */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  /* ---------- utilidades ---------- */
  function fmtMoney(n, symbol) {
    symbol = symbol || "$";
    n = Math.round(Number(n) || 0);
    return symbol + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function getConfig() {
    try {
      var el = document.getElementById("ns-config");
      if (el) return JSON.parse(el.textContent);
    } catch (e) {}
    return {};
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".ns-reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("ns-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("ns-in");
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- scroll suave a anclas internas ---------- */
  function initAnchors() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#ns-"]');
      if (!a) return;
      var href = a.getAttribute("href");
      if (!href || href.indexOf("http") === 0) return;
      var id = href.slice(1);
      var t = document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  }

  /* ---------- botones de WhatsApp globales (.ns-wa-link) ---------- */
  function initWaLinks() {
    var cfg = getConfig();
    var num = (cfg.wa || "").replace(/[^0-9]/g, "");
    document.querySelectorAll(".ns-wa-link").forEach(function (a) {
      var msg = a.getAttribute("data-ns-wamsg") || cfg.msg || "";
      if (num) {
        a.href = "https://wa.me/" + num + (msg ? "?text=" + encodeURIComponent(msg) : "");
        a.target = "_blank";
        a.rel = "noopener";
      }
    });
  }

  /* ---------- barra de compra fija ---------- */
  function initSticky() {
    var bar = document.querySelector("[data-ns-sticky]");
    if (!bar) return;
    var hero = document.querySelector(".ns-hero");
    var order = document.getElementById("ns-pedido");
    function onScroll() {
      var trigger = hero ? (hero.offsetTop + hero.offsetHeight - 200) : 480;
      var show = window.pageYOffset > trigger;
      // ocultar si el formulario de pedido está a la vista
      if (show && order) {
        var r = order.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9 && r.bottom > 0) show = false;
      }
      bar.classList.toggle("ns-show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- tabs (usos) ---------- */
  function initTabs() {
    document.querySelectorAll("[data-ns-tabs]").forEach(function (wrap) {
      var tabs = wrap.querySelectorAll("[data-ns-tab]");
      var panels = wrap.querySelectorAll("[data-ns-panel]");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var idx = tab.getAttribute("data-ns-tab");
          tabs.forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
          panels.forEach(function (p) {
            p.setAttribute("data-active", p.getAttribute("data-ns-panel") === idx ? "true" : "false");
          });
        });
      });
    });
  }

  /* ---------- formulario de pedido ---------- */
  function initOrder() {
    var form = document.querySelector("[data-ns-order]");
    if (!form) return;

    var unit = parseFloat(form.dataset.unit) || 0;
    var ship = parseFloat(form.dataset.ship) || 0;
    var free = form.dataset.free === "true";
    var symbol = form.dataset.symbol || "$";
    var variant = form.dataset.variant || "";
    var waNum = (form.dataset.wa || "").replace(/[^0-9]/g, "");
    var productName = form.dataset.product || "Producto";
    var cartUrl = form.dataset.cart || "/cart";

    var qtyInput = form.querySelector("[data-ns-qty]");
    var prepHidden = form.querySelector("#ns-prep");
    var buyBtn = form.querySelector("[data-ns-buy]");
    var waBtn = form.querySelector("[data-ns-wabtn]");
    var action = "buy";

    if (buyBtn) buyBtn.addEventListener("click", function () { action = "buy"; });
    if (waBtn) waBtn.addEventListener("click", function () { action = "wa"; });

    function qty() {
      var q = parseInt(qtyInput.value, 10);
      if (isNaN(q) || q < 1) q = 1;
      if (q > 20) q = 20;
      return q;
    }
    function shipVal() { return free ? 0 : ship; }
    function setText(sel, val) { var el = form.querySelector(sel); if (el) el.textContent = val; }

    function update() {
      var q = qty();
      var sub = unit * q;
      setText("[data-ns-qtylabel]", "×" + q);
      setText("[data-ns-subtotal]", fmtMoney(sub, symbol));
      setText("[data-ns-ship]", free ? "¡Gratis!" : fmtMoney(shipVal(), symbol));
      setText("[data-ns-total]", fmtMoney(sub + shipVal(), symbol));
    }

    var plus = form.querySelector("[data-ns-qtyplus]");
    var minus = form.querySelector("[data-ns-qtyminus]");
    if (plus) plus.addEventListener("click", function () { qtyInput.value = Math.min(20, qty() + 1); update(); });
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(1, qty() - 1); update(); });
    if (qtyInput) qtyInput.addEventListener("input", update);

    var chips = form.querySelectorAll("[data-ns-chip]");
    chips.forEach(function (c) {
      c.addEventListener("click", function () {
        var on = c.getAttribute("aria-pressed") === "true";
        c.setAttribute("aria-pressed", on ? "false" : "true");
        var sel = [];
        chips.forEach(function (x) { if (x.getAttribute("aria-pressed") === "true") sel.push(x.getAttribute("data-ns-chip")); });
        if (prepHidden) prepHidden.value = sel.join(", ");
      });
    });

    update();

    function val(id) { var el = form.querySelector(id); return el ? el.value.trim() : ""; }
    function mark(id, isBad) {
      var el = form.querySelector(id);
      if (!el) return false;
      var wrap = el.closest(".ns-field");
      var err = wrap ? wrap.querySelector(".ns-field-error") : null;
      if (isBad) { el.classList.add("ns-invalid"); if (err) err.style.display = "block"; }
      else { el.classList.remove("ns-invalid"); if (err) err.style.display = "none"; }
      return isBad;
    }
    function payMethod() {
      var r = form.querySelector('input[name="properties[Método de pago]"]:checked');
      return r ? r.value : "";
    }
    function fullAddress() {
      var parts = [val("#ns-address")];
      if (val("#ns-barrio")) parts.push("Barrio " + val("#ns-barrio"));
      if (val("#ns-compl")) parts.push(val("#ns-compl"));
      return parts.join(", ");
    }

    function buildWaText() {
      var L = [];
      L.push("¡Hola NextSells! Quiero hacer este pedido:");
      L.push("");
      L.push("🛒 " + productName);
      L.push("Cantidad: " + qty());
      if (prepHidden && prepHidden.value) L.push("Para preparar: " + prepHidden.value);
      L.push("");
      L.push("👤 Nombre: " + val("#ns-name"));
      L.push("📱 Celular: " + val("#ns-phone"));
      L.push("📧 Correo: " + val("#ns-email"));
      L.push("🏙️ Ciudad: " + val("#ns-city") + (val("#ns-dept") ? ", " + val("#ns-dept") : ""));
      L.push("📍 Dirección: " + fullAddress());
      L.push("💳 Pago: " + payMethod());
      if (val("#ns-notes")) L.push("📝 Notas: " + val("#ns-notes"));
      L.push("");
      L.push("💰 Subtotal: " + fmtMoney(unit * qty(), symbol) + " + envío");
      return L.join("\n");
    }

    function setBusy(busy) {
      [buyBtn, waBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = busy;
        b.style.opacity = busy ? "0.7" : "1";
      });
    }

    function addToCart() {
      if (!variant) return Promise.resolve();
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
        if (inp.type === "radio" && !inp.checked) return;
        var m = inp.name.match(/properties\[(.+)\]/);
        if (!m) return;
        if (inp.value) props[m[1]] = inp.value;
      });
      var body = { items: [{ id: Number(variant), quantity: qty(), properties: props }] };
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var note = "Pedido NextSells — " + val("#ns-name") + " / " + val("#ns-phone") + " / " + val("#ns-city") + " / " + payMethod();
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              note: note,
              attributes: {
                "Cliente": val("#ns-name"),
                "Celular": val("#ns-phone"),
                "Correo": val("#ns-email"),
                "Ciudad": val("#ns-city"),
                "Departamento": val("#ns-dept"),
                "Dirección": fullAddress(),
                "Método de pago": payMethod()
              }
            })
          });
        })
        .catch(function () {});
    }

    function checkoutUrl() {
      var name = val("#ns-name").split(/\s+/);
      var first = name[0] || "";
      var last = name.slice(1).join(" ");
      var addr2 = [];
      if (val("#ns-barrio")) addr2.push("Barrio " + val("#ns-barrio"));
      if (val("#ns-compl")) addr2.push(val("#ns-compl"));
      var q = [];
      function add(k, v) { if (v) q.push(k + "=" + encodeURIComponent(v)); }
      add("checkout[email]", val("#ns-email"));
      add("checkout[shipping_address][first_name]", first);
      add("checkout[shipping_address][last_name]", last);
      add("checkout[shipping_address][address1]", val("#ns-address"));
      add("checkout[shipping_address][address2]", addr2.join(", "));
      add("checkout[shipping_address][city]", val("#ns-city"));
      add("checkout[shipping_address][province]", val("#ns-dept"));
      add("checkout[shipping_address][country]", "Colombia");
      add("checkout[shipping_address][phone]", val("#ns-phone"));
      return "/checkout" + (q.length ? "?" + q.join("&") : "");
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var bad = false;
      bad = mark("#ns-name", val("#ns-name").length < 2) || bad;
      bad = mark("#ns-phone", val("#ns-phone").replace(/[^0-9]/g, "").length < 7) || bad;
      bad = mark("#ns-email", !/^\S+@\S+\.\S+$/.test(val("#ns-email"))) || bad;
      bad = mark("#ns-dept", val("#ns-dept") === "") || bad;
      bad = mark("#ns-city", val("#ns-city").length < 2) || bad;
      bad = mark("#ns-address", val("#ns-address").length < 4) || bad;
      if (bad) {
        var f = form.querySelector(".ns-invalid");
        if (f) f.focus();
        return;
      }

      var waUrl = waNum ? "https://wa.me/" + waNum + "?text=" + encodeURIComponent(buildWaText()) : "";
      var isWa = action === "wa" || (!variant && waUrl); // sin producto: solo WhatsApp

      setBusy(true);

      if (isWa) {
        // Abrir WhatsApp de inmediato (conserva el gesto del usuario) y registrar el carrito de fondo
        var win = waUrl ? window.open(waUrl, "_blank") : null;
        addToCart().then(function () {
          if (!win && waUrl) { window.location.href = waUrl; return; }
          setBusy(false);
          if (waBtn) waBtn.textContent = "¡Listo! Continúa en WhatsApp";
        });
      } else {
        addToCart().then(function () {
          window.location.href = variant ? checkoutUrl() : (cartUrl || "/cart");
        });
      }
    });
  }

  ready(function () {
    initReveal();
    initAnchors();
    initWaLinks();
    initSticky();
    initTabs();
    initOrder();
  });
})();
